// Expose Core API globally
import "./exports/index";

import "react-loading-skeleton/dist/skeleton.css";

// Import global SCSS
import "../scss/style.scss";

// Import Consent Manager BEFORE anything else that might need it
import "./common/features/cookieConsent/ConsentManager";

// lazysizes self-initializes on import
import "lazysizes";
// Import the RIAS plugin to handle high-density displays automatically
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

// --- GSAP Animation Engine ---
import { initScrollAnimations } from "./common/animation/scrollAnimations";

import "./app/i18n";

// Import and initialize Quicklink
import { listen } from "quicklink";

// Import store to ensure it's initialized
import { store } from "./app/store";

// Import hydration system
import { hydrateComponents } from "./app/hydrate";

// Import the url sync helper
import { syncLanguageToUrl } from "./common/helpers/syncLanguageToUrl";

// Header Logic
import { initDefaultTopBarSwiper } from "./parts/header/topBarDefault";
import { initNocTopBarSwiper } from "./parts/header/topBarNoc";
import { initNocStickyHeader } from "./parts/header/stickyHeaderNoc";
import { initMobileMenuOffcanvas } from "./parts/header/mobileMenu"; // Shared logic

import { initArchiveMasonry } from "./partials/PageContent/archiveMasonry";
import { initHeroSlider } from "./partials/PageContent/heroSlider";
import { initHeroBento } from "./partials/PageContent/heroBento";
import { initCtaSlider } from "./partials/PageContent/ctaSlider";
import { initCtaImageParallax } from "./partials/PageContent/ctaImage";
import { initCategoriesSlider } from "./partials/PageContent/categoriesSlider";
import { initArchiveShowcaseVideos } from "./partials/PageContent/archiveShowcase";
import { initArticleWSlider } from "./partials/PageContent/articleWSlider";

import { initVideoFacades } from "./partials/PostContent/video";
import { initGalleries } from "./partials/PostContent/gallery";
import { initAccordions } from "./partials/PostContent/accordion";

// Initialize Global Logic
const initGlobals = () => {
  // Run the URL sync logic first
  syncLanguageToUrl();

  // Initialize Scroll Animations (GSAP)
  initScrollAnimations();

  // Header Initialization
  // These functions have internal guard clauses, so they won't conflict
  // if the elements aren't present in the DOM.
  initDefaultTopBarSwiper();
  initNocTopBarSwiper();
  initNocStickyHeader();
  initMobileMenuOffcanvas();

  // Page Components
  initArchiveMasonry();
  initHeroSlider();
  initHeroBento();
  initCtaSlider();
  initCtaImageParallax();
  initCategoriesSlider();
  initArchiveShowcaseVideos();
  initArticleWSlider();

  // Post Components
  initVideoFacades();
  initGalleries();
  initAccordions();

  // Initialize Quicklink. It will automatically start listening for in-viewport links.
  listen();

  // Hydrate all React components found on the page
  hydrateComponents();

  // Reference 'store' in the log to satisfy the TypeScript "unused variable" check
  console.log(
    `[Main JS] Main JS bundle initialized. Store status: ${!!store ? "Active" : "Missing"}`,
  );
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
